import './App.css';
import './fonts/Bobby_Jones_Soft.otf'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home';
import GetWlSpot from './pages/get-wlspot';
import MarketPlace from './pages/market-place';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/marketplace" element={<MarketPlace />} />
        <Route path="/wlspot" element={<GetWlSpot />} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
